import React from 'react';
import { toast } from 'react-toastify';
import { CheckCircle, Download, X } from 'lucide-react';

const VersionUpdateToast = ({ closeToast, version, releaseNotes }) => {
  return (
    <div className="w-full max-w-md p-4 bg-white border border-gray-200 rounded-lg shadow-lg">
      <div className="flex justify-between items-start">
        <div className="flex items-start">
          <div className="p-2 bg-green-100 rounded-full mr-3">
            <CheckCircle className="h-5 w-5 text-green-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">New Version Available!</h3>
            <p className="text-sm text-gray-600 mt-1">Version {version} is ready to install</p>
            {releaseNotes && (
              <details className="mt-2">
                <summary className="text-sm text-blue-600 cursor-pointer">Release notes</summary>
                <p className="text-xs text-gray-500 mt-1">{releaseNotes}</p>
              </details>
            )}
          </div>
        </div>
        <button 
          onClick={closeToast}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-4 flex justify-end space-x-3">
        <button
          onClick={() => {
            // Add your update logic here
            window.location.reload(); // Simple refresh for demo
            closeToast();
          }}
          className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors flex items-center"
        >
          <Download className="h-4 w-4 mr-1" />
          Update Now
        </button>
        <button
          onClick={closeToast}
          className="px-3 py-1.5 border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50 transition-colors"
        >
          Later
        </button>
      </div>
    </div>
  );
};

export const showVersionUpdateToast = (version, releaseNotes) => {
  toast(
    ({ closeToast }) => (
      <VersionUpdateToast 
        closeToast={closeToast} 
        version={version}
        releaseNotes={releaseNotes}
      />
    ),
    {
      position: "bottom-right",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: false,
      className: '!p-0 !bg-transparent !shadow-none',
    }
  );
};

export default VersionUpdateToast;